import { createOrganizationStyleService } from "toptaal-shared"
import apiClient from "../client"
import {
  OrganizationInput,
  OrganizationResponse,
  OrganizationStyle,
} from "../types/organization"

const organizationStyleService = createOrganizationStyleService({
  baseEndpoint: "organization",
})

export async function getOrganization() {
  return await apiClient.get<OrganizationResponse>("organization").json()
}

export async function getOrganizationStyle() {
  return await apiClient.get<OrganizationStyle>("organization/style").json()
}

export async function editOrganization({
  organization,
}: {
  organization: OrganizationInput
}) {
  return await apiClient
    .put<OrganizationResponse>("organization", {
      json: { organization },
    })
    .json()
}

export const updateOrganizationStyle =
  organizationStyleService.updateStyle.bind(organizationStyleService)
export const getOrganizationStyleCompanyPicture =
  organizationStyleService.getStyleCompanyPicture.bind(organizationStyleService)
export const uploadOrganizationLogo = organizationStyleService.uploadLogo.bind(
  organizationStyleService,
)
